import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@/services/api'
import { DistributionMode, DistributionModeUpdateRequest } from '@/types'
import { toast } from 'sonner'

const DISTRIBUTION_MODES_QUERY_KEY = 'distribution-modes'

export const useDistributionModes = () => {
  return useQuery<DistributionMode[]>({
    queryKey: [DISTRIBUTION_MODES_QUERY_KEY],
    queryFn: async () => {
      const { data } = await api.get('/credit-costs/distribution-modes')
      return data
    },
  })
}

export const useUpdateDistributionMode = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, updates }: { id: string; updates: DistributionModeUpdateRequest }) => {
      const { data } = await api.patch(`/credit-costs/distribution-modes/${id}`, updates)
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DISTRIBUTION_MODES_QUERY_KEY] })
      toast.success('Modo de distribucion actualizado')
    },
  })
}

export const useToggleDistributionMode = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (id: string) => {
      const { data } = await api.post(`/credit-costs/distribution-modes/${id}/toggle`)
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DISTRIBUTION_MODES_QUERY_KEY] })
      toast.success('Estado del modo de distribucion actualizado')
    },
  })
}
